import './styles.scss'

import React from 'react'
import { useValues } from 'kea'

import I18n from 'lib/i18n'

import courseLogic from '~/scenes/course/show/logic'

const GeneralInfo = () => {
  const { course } = useValues(courseLogic)
  const { studentAges, studentLevels, durations, languages } = course

  return (
    <div className='general-info-container'>
      <div className='card'>
        <div className='card-title'>{I18n.t('courses.show.age_start').slice(0, -1)}</div>
        <div className='card-content'>
          {studentAges.map(age => (
            <div key={age}>{age}</div>
          ))}
        </div>
      </div>

      <div className='card'>
        <div className='card-title'>{I18n.t('courses.show.student_level').slice(0, -1)}</div>
        <div className='card-content'>
          {studentLevels.map(level => (
            <div key={level}>{level}</div>
          ))}
        </div>
      </div>

      <div className='card'>
        <div className='card-title'>{I18n.t('courses.show.duration').slice(0, -1)}</div>
        <div className='card-content'>
          {durations.map(duration => (
            <div key={duration}>{duration}</div>
          ))}
        </div>
      </div>

      <div className='card'>
        <div className='card-title'>{I18n.t('courses.show.languages').slice(0, -1)}</div>
        <div className='card-content'>
          {languages.split(', ').map(language => (
            <div key={language}>{language}</div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default GeneralInfo
